import { render, staticRenderFns } from "./baseInformation.vue?vue&type=template&id=75bbfb54&scoped=true"
import script from "./baseInformation.vue?vue&type=script&lang=js"
export * from "./baseInformation.vue?vue&type=script&lang=js"
import style0 from "./baseInformation.vue?vue&type=style&index=0&id=75bbfb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbfb54",
  null
  
)

export default component.exports